import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { gql, useReactiveVar } from "@apollo/client";
import { currentBusinessIdVar, createAccountJobIdVar, currentShopifyVersionVar, dummyFunc } from "../helpers/client";
import { i18nManager } from "../helpers/tools";
import Button, { ButtonVariant } from "./Button";
import CustomerAnalyticsReport from "./CustomerAnalyticsReport";
import TitleBar, { WithfriendsAction } from "./WithfriendsTitleBar";
import { useAppBridge } from "@shopify/app-bridge-react";
import { Redirect } from "@shopify/app-bridge/actions";
import { usePollCreateAccountJobQuery, usePollImportCompletedQuery } from "../types";
// @ts-ignore
import { useNavigate } from 'react-router-dom';
import { I18nContext } from '@shopify/react-i18n';
import { Card } from "@tremor/react";
gql `
query PollCreateAccountJob($id: ID!) {
  jobFinished(id: $id)
}
`;
gql `
query PollImportCompleted($id: ID!){
  business(id: $id) {
    id
    importAnalytics {
      averageOrderValue {
        amount
      }
      customerVisitFrequency
    }
  }
}
`;
const CustomerAnalyticsScreen = ({ useSyncShopifyDataMutation = dummyFunc }) => {
    var _a, _b;
    // TODO - can't seem to abstract this out without React crashing, so we gotta copy and paste it into any relevant file
    let app, redirect = null;
    let navigate = useNavigate();
    try {
        app = useAppBridge();
        redirect = Redirect.create(app);
    }
    catch (e) { }
    const VisitLink = (url) => {
        (redirect ?
            redirect.dispatch(Redirect.Action.APP, url) :
            navigate(url));
    };
    // TODO - end
    const currentBusinessId = useReactiveVar(currentBusinessIdVar);
    const createAccountJobId = useReactiveVar(createAccountJobIdVar);
    const currentShopifyVersion = useReactiveVar(currentShopifyVersionVar);
    const { data, stopPolling } = usePollCreateAccountJobQuery({
        variables: {
            id: createAccountJobId,
        },
        skip: !createAccountJobId,
        pollInterval: 2000
    });
    const { data: dataV2, stopPolling: stopPollingV2 } = usePollImportCompletedQuery((currentShopifyVersion == 2) ? { variables: { id: currentBusinessId }, skip: !currentBusinessId, pollInterval: 5000 } : null);
    if (!currentBusinessId) {
        VisitLink("/setup");
    }
    const continueButton = () => {
        VisitLink("/memberships");
    };
    if (!createAccountJobId || (data === null || data === void 0 ? void 0 : data.jobFinished)) {
        stopPolling();
    }
    if (!!((_a = dataV2 === null || dataV2 === void 0 ? void 0 : dataV2.business) === null || _a === void 0 ? void 0 : _a.importAnalytics) || currentShopifyVersion != 2) {
        stopPollingV2();
    }
    return (_jsxs("div", { className: "flex flex-col justify-center", children: [_jsx(TitleBar, { action: WithfriendsAction.Analytics, useSyncShopifyDataMutation: useSyncShopifyDataMutation }), _jsx("h2", { className: "text-4xl font-light max-w-xl w-full mb-4", children: "Your Customer Analytics." }), ((createAccountJobId && !(data === null || data === void 0 ? void 0 : data.jobFinished)) || (currentShopifyVersion == 2 && !((_b = dataV2 === null || dataV2 === void 0 ? void 0 : dataV2.business) === null || _b === void 0 ? void 0 : _b.importAnalytics))) ? (_jsx("div", { className: "font-heavy mb-4 text-salmon-600 animate animate-pulse", children: "We're still loading your customer data..." })) : (_jsx("div", { className: "font-heavy mb-4 text-salmon-600" })), _jsx(I18nContext.Provider, { value: i18nManager(), children: _jsx(Card, { className: "rounded-none", children: _jsx(CustomerAnalyticsReport, { id: currentBusinessId }) }) }), _jsx("div", { className: "my-4 w-full" }), _jsx("div", { className: "w-full flex-none mb-16 sm:mb-0", children: _jsx(Button, { variant: ButtonVariant.Salmon, onClick: continueButton, children: "Continue to Design Your Memberships" }) }), _jsx("div", { className: "w-full flex-auto" })] }));
};
export default CustomerAnalyticsScreen;
